// extracted by mini-css-extract-plugin
export default {"section":"DetailSection_section__zz2mX","sectionTitle":"DetailSection_sectionTitle__vHBA8","grid":"DetailSection_grid__RSfud","empty":"DetailSection_empty__AqtL+"};